import { Component, OnInit } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { Router, Routes } from '@angular/router';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { DialogFormConfirmComponent } from '../dialog-form-confirm/dialog-form-confirm.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import { DialogIncidentCloseComponent } from '../dialog-incident-close/dialog-incident-close.component';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/services/security/login.service';


@Component({
  selector: 'neoris-incident-health-safety-control-tower',
  templateUrl: './incident-health-safety-control-tower.component.html',
  styleUrls: ['./incident-health-safety-control-tower.component.css']
})
export class IncidentHealthSafetyControlTowerComponent implements OnInit {
  incidentRecordData: any 
  incidentRecordDatFrom:any={}
  search:string=''
  private Sendclick:number = 0
  incidentFormData:any={}
  private onIncidentRecord:Subscription
  private onDataFormIncident:Subscription


  constructor(private propertiesService:PropertiesTowers,
    private route:Router,
    private dialog: MatDialog,
    private controltowerservice:ControltowerService,
    private _snackBar: MatSnackBar,
    private securityService: LoginService
   ) { 
    this.Sendclick = 0
   }

 async ngOnInit(): Promise<void> {
  const userName = JSON.parse(localStorage.getItem('ud'))[1].value
  const guid = JSON.parse(localStorage.getItem('guidSession'))
  const response = await this.securityService.login(userName,guid).toPromise()

   await this.getIncidentRecordModal()
   await this.getDataFormIncident()


   

 
  
    
  }

   async getIncidentRecordModal(){
     this.onIncidentRecord = this.propertiesService.listeningIncidentRecordModal.subscribe((value) =>{
      console.log('listeningIncidentRecordModal',value)
      if(value != null) {
        console.log('valores recuperados form record--->',value)
        this.recoveryDataIncidentRecord(value)
      }
    })
  }

   async getDataFormIncident(){
    this.onDataFormIncident =this.propertiesService.listeningDataFormIncident.subscribe((value) =>{
      console.log('valores recibidos',value)
      if(value != null) {
        if(value[1] > 0){
       this.saveFormIncidentAndExit(value[0],value[1])
        }
        
      }
    })
  }


  back(){
    console.log('go back')
    this.route.navigate(['/health-safety-control-tower-dashboard'])
  }


  openDialog(): void {
    this.dialog.open(DialogFormConfirmComponent,
      {
        restoreFocus: false,
        width: '600px'
    });
  }


  openDialogCloseIncident(): void {
    this.dialog.open(DialogIncidentCloseComponent,
      {
        restoreFocus: false,
        width: '600px'
    });
  }

  

  checkFormIncident(btnNumber:any){
    this.Sendclick = btnNumber
    this.propertiesService.setClickBtnFormIncident(this.Sendclick)
  }

   recoveryDataIncidentRecord(data:any){

    this.incidentRecordData = JSON.parse(localStorage.getItem('rowSelectEvent'))

    this.incidentRecordData.actionTaken = data.ActionsTaken
    this.incidentRecordData.responsible = data.Responsible
    this.incidentRecordData.dueDate = data.DueDate

    console.log('data from incident record',data)

  }

   async saveFormIncidentAndExit(data:any,btnNumber:number){
   await new Promise(resolve => setTimeout(resolve, 3000))

    console.log('data recibida form incident',data)

    console.log('data from incident record 2', this.incidentRecordDatFrom)

    data.actionsTaken = this.incidentRecordDatFrom.ActionsTaken
    data.dueDate = this.incidentRecordDatFrom.DueDate
    data.eventDescription = this.incidentRecordDatFrom.Event
    data.responsible = this.incidentRecordDatFrom.Responsible
    

    if(btnNumber == 1){
      data.incidentStatusId = '10001' 

    }
    else{
      data.incidentStatusId = '10003' 
    }
    
    let success = await this.SaveFormIncident(data)

    console.log('respuesta save incidents',success)

    if(success.data.result){
  
      this.openSnackBar(success.data.message,'OK')
      this.route.navigate(['/health-safety-control-tower-dashboard'])
    }
    else{
      this.openSnackBar(success.data.message,'ERROR')
    }

  }

  openSnackBar(message: string, action: string) {
    if(action == 'OK'){
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar']
    });
  }
  else{
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar-false']
    });
  }
  }


  
  private async SaveFormIncident(request:any): Promise<any> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.SaveFormIncident(request).subscribe(
        {
          next: (incident: any) => {
            console.log('respondio el save incident:',incident);
                                  
            resolve(incident);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  ngOnDestroy():void{

    this.onDataFormIncident.unsubscribe()
    this.onIncidentRecord.unsubscribe()
    
  }

}
